export default __webpack_public_path__ + "static/media/ELEMENTOS_04.d40b8d0b.png";